import cx from "classnames";
import { type FC, type HTMLAttributes, type ReactNode } from "react";

/**
 * <RowContent/>
 */

export type RowContentProps = {
	cellID?: string;
	children?: ReactNode;
	rootProps?: HTMLAttributes<HTMLDivElement>;
};

export const RowContent: FC<RowContentProps> = ({ cellID, rootProps, children }) => {
	const { className: rootStyles, ...rootPropsRest } = rootProps || {};
	const styles = [
		"canvas-content-row",
		// IMPORTANT: `overflow-x-auto` is REQUIRED to allow datagrid to "overflow" to the right.
		"overflow-x-auto",
		{ "h-full": false },
		rootStyles,
	];

	return (
		<div
			className={cx(styles)}
			// needed for prosemirror to insert content
			data-row-content
			// used by prosemirror to identify the cellID that row hold content for
			data-cell-contents={cellID}
			{...rootPropsRest}
		>
			{children}
		</div>
	);
};
